/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */

interface StoriesSummaryProps {
    numStoriesOn: number;
    numStoriesMaintenance: number;
    numStoriesDraft: number;
    numStoriesDisabled: number;
}

export default function StoriesSummary({
    numStoriesOn,
    numStoriesMaintenance,
    numStoriesDraft,
    numStoriesDisabled,
}: StoriesSummaryProps) {
    const total = numStoriesOn + numStoriesMaintenance + numStoriesDraft + numStoriesDisabled;

    // Calculate percentages
    const percentOn = total > 0 ? (numStoriesOn / total) * 100 : 0;
    const percentMaintenance = total > 0 ? (numStoriesMaintenance / total) * 100 : 0;
    const percentDraft = total > 0 ? (numStoriesDraft / total) * 100 : 0;
    const percentDisabled = total > 0 ? (numStoriesDisabled / total) * 100 : 0;

    return (
        <div className="w-full max-w-3xl mx-auto mb-6">
            <div className="h-2 w-full flex rounded-full overflow-hidden mb-3">
                <div
                    className="bg-green h-full transition-all duration-500 ease-in-out"
                    style={{ width: `${percentOn}%` }}
                    title={`${Math.round(percentOn)}% active stories`}
                />
                <div
                    className="bg-yellow-500 h-full transition-all duration-500 ease-in-out"
                    style={{ width: `${percentMaintenance}%` }}
                    title={`${Math.round(percentMaintenance)}% maintenance stories`}
                />
                <div
                    className="bg-purple-500 h-full transition-all duration-500 ease-in-out"
                    style={{ width: `${percentDraft}%` }}
                    title={`${Math.round(percentDraft)}% draft stories`}
                />
                <div
                    className="bg-slate-400 h-full transition-all duration-500 ease-in-out"
                    style={{ width: `${percentDisabled}%` }}
                    title={`${Math.round(percentDisabled)}% disabled stories`}
                />
            </div>

            <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm">
                <div className="flex items-center gap-1.5">
                    <div className="w-3 h-3 rounded-full bg-green" />
                    <span className="text-slate-700">
                        <span className="font-semibold">{numStoriesOn}</span> Active
                    </span>
                </div>
                <div className="flex items-center gap-1.5">
                    <div className="w-3 h-3 rounded-full bg-yellow-500" />
                    <span className="text-slate-700">
                        <span className="font-semibold">{numStoriesMaintenance}</span> Maintenance
                    </span>
                </div>
                <div className="flex items-center gap-1.5">
                    <div className="w-3 h-3 rounded-full bg-purple-500" />
                    <span className="text-slate-700">
                        <span className="font-semibold">{numStoriesDraft}</span> Draft
                    </span>
                </div>
                <div className="flex items-center gap-1.5">
                    <div className="w-3 h-3 rounded-full bg-slate-400" />
                    <span className="text-slate-700">
                        <span className="font-semibold">{numStoriesDisabled}</span> Disabled
                    </span>
                </div>
                <div className="flex items-center gap-1.5">
                    <p className=" text-slate-400">Total: {total}</p>
                </div>
            </div>
        </div>
    );
}
